"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContact = void 0;
/**
 * Get a contact from the storage
 *
 * @alpha
 * @typeParam T The type of the repository that should be derived from {@link IContactRepository}
 * @param repository The repository instance to handle contacts. See {@link contactRepository}
 *
 * @returns A contact if found in storage otherwise null
 *
 * @example
 * ```ts
 * getContact(contactRepository); // null or IContact
 * ```
 */
function getContact(repository) {
    return repository.getContact();
}
exports.getContact = getContact;
//# sourceMappingURL=get-contact.js.map